<template>
    <div class="iframe-viewer">
        <div class="iframe-header">
            <button class="back-button" @click="goBack">
                <span class="back-icon">←</span>
                <span>返回BIM星球</span>
            </button>
            <span class="current-title">{{ title }}</span>
        </div>
        <div class="iframe-container">
            <iframe 
                :src="url" 
                frameborder="0" 
                allowfullscreen
                class="iframe-content"
            ></iframe>
        </div>
    </div>
</template>

<script>
export default {
    name: 'IframeViewer',
    props: {
        url: {
            type: String,
            required: true
        },
        title: {
            type: String,
            default: ''
        }
    },
    methods: {
        goBack() {
            this.$emit('back');
        }
    }
}
</script>

<style scoped>
.iframe-viewer {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    background: #fff;
    border-radius: 20px;
    overflow: hidden;
}

.iframe-header {
    display: flex;
    align-items: center;
    padding: 12px 20px;
    background: linear-gradient(to right, #003366, #005ea2);
    color: white;
    gap: 20px;
}

.back-button {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 6px;
    color: white;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.back-button:hover {
    background: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.5);
}

.back-icon {
    font-size: 18px;
    font-weight: bold;
}

.current-title {
    font-size: 16px;
    font-weight: 600;
}

.iframe-container {
    flex: 1;
    width: 100%;
    overflow: hidden;
}

.iframe-content {
    width: 100%;
    height: 100%;
    border: none;
}
/* .header-container--t7QQLkY3dEolJHdf {
    display: none;
} */
 .semi-icon{
    display: none;
 }
</style>
